import React from 'react';
import Locale from '../domain/Locale';
import ProductDomain from '../domain/Product';
import Color from '../domain/Color';
import Amount from '../domain/Amount';
import getBundle from '../domain/get_bundle';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  product: ProductDomain,
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color)
})
export default class ProductBand extends React.Component {

  getListPrice() {
    return Amount.format(this.props.locale, this.props.product.currency, this.props.product.list_price);
  }

  getCurrency() {
    return this.props.locale.locale_bundle().currency[this.props.product.currency];
  }

  getBestDeal() {
    return this.props.locale.format_integer(this.props.product.runtime.best.price);
  }

  getBestDealIcon() {
    if (!(this.props.product.runtime) || !(this.props.product.runtime.best)) {
      return null;
    }
    return (<div className="best_deal"><div>{getBundle(this.props.locale).product.best_deal}<br/>{this.getCurrency()} {this.getBestDeal()}</div></div>);
  }

  render() {
    const styleBand = {
      backgroundColor: this.props.themeBgColor,
      color: this.props.themeBgFontColor
    };
    return (
      <div className="product_band" style={styleBand}>
        <h1><del>{this.getListPrice()}</del></h1>
        {this.getBestDealIcon()}
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductBand.js
 **/